import * as Yup from 'yup';

export const validationSchemaQuote = Yup.object().shape({
  accountId: Yup.string().required('Account Name is required'),
  subject: Yup.string().required('Subject is required'),
  quoteDetails: Yup.array().of(
    Yup.object().shape({
      productId: Yup.string().required('Product Name is required'),
    })
  ),
});
